// extracted by mini-css-extract-plugin
export default {"wrapper":"ZZxpP0tAqq8qG4XyDHNb"};